module.exports = __webpack_public_path__ + "static/media/pekip-logo.fb21734c.png";